import { useMemo, useRef } from 'react';

// Suivi d'écoute / de visionnage : reprise à la dernière position + sauvegarde toutes les 10 s, à la pause et à la fin.
export function useMediaTracking(item, api, onProgress) {
  const last = useRef(0);
  const opened = useRef(false);
  return useMemo(() => {
    const save = (el) => {
      if (!el || !el.duration || Number.isNaN(el.duration)) return;
      api().put(`/formation/items/${item.id}/progress`, { position: el.currentTime, duration: el.duration })
        .then(({ data }) => onProgress?.(item.id, { my_progress: data.percent, my_last_position: data.last_position }))
        .catch(() => {});
    };
    return {
      onLoadedMetadata: (e) => {
        const el = e.currentTarget;
        const p = item.my_last_position || 0;
        if (p > 5 && (item.my_progress || 0) < 95 && p < el.duration - 5) el.currentTime = p;
      },
      onPlay: () => {
        if (opened.current) return;
        opened.current = true;
        api().post(`/formation/items/${item.id}/open`).catch(() => {});
      },
      onTimeUpdate: (e) => {
        const now = Date.now();
        if (now - last.current > 10000) { last.current = now; save(e.currentTarget); }
      },
      onPause: (e) => save(e.currentTarget),
      onEnded: (e) => save(e.currentTarget),
    };
  }, [item.id, item.my_last_position, item.my_progress, api, onProgress]);
}

export const ProgressBar = ({ value, testid }) => (
  <div className="flex items-center gap-2" data-testid={testid}>
    <span className="flex-1 h-1.5 rounded-full bg-surface-2 overflow-hidden">
      <span className={`block h-full ${value >= 95 ? 'bg-emerald-500' : 'bg-orange'} transition-all`} style={{ width: `${Math.min(value || 0, 100)}%` }} />
    </span>
    <span className="text-[11px] tabular-nums text-text-3 w-9 text-right">{Math.round(value || 0)} %</span>
  </div>
);
